<template>
  <div
    class="after-parties"
    :style="{'color': landingPage.themeColor,'background': value.inverseColors?landingPage.secondaryColor:landingPage.negativeColor}">
    <div class="_1200">
      <h2 class="sec-head">
        <strong>{{ tinaswishValue /*value.title*/ }}</strong>
      </h2>
      <div v-if="tinaswishLink" class="links-box">
        <a href="https://tinaswishbenefit.com" class="party-link w-button" :style="{'background': landingPage.themeColor, 'color': landingPage.negativeColor}"
          >Click Here</a
        >
      </div>
      <div v-else class="links-box">
        <a
          v-for="link in value.linkBox"
          :key="link._id"
          @click="openPopup(link.item)"
          class="party-link w-button"
          :class="{'link-image':linkWithImage(link)}"
          :style="style(link)"
          >
          <img v-if="linkWithImage(link)" :src="link.item.image.imageURL" />
          {{ link.item.name }}
          <p v-if="linkWithImage(link)" class="play-icon">►</p>
        </a>
      </div>
      <popup v-model="popup">
        <iframe
          :src="popup"
          frameborder="0"
          autoplay
          allow="autoplay"
          class="video-frame"
        ></iframe>
        <p style="color:white">{{videoCaption}}</p>
      </popup>
    </div>
  </div>
</template>

<script>
export default {
  name: "link-box",
  props: {
    value: Object,
    landingPage: Object,
  },
  data() {
    return {
      popup: false,
      videoCaption:""
    };
  },
  methods: {
    openPopup(item) {
      if (item.videoLink) {
        this.popup = item.videoLink;
        this.videoCaption = item.videoCaption
      } else {
        window.open(item.link, "_blank")
      }
    },
    linkWithImage(link) {
      return link.item.image && link.item.image.imageURL != ''
    },
    style(link) {
      if (link.item.invertColors) {
        return {'background': this.landingPage.inverseColors, 'color': this.value.inverseColors?this.landingPage.themeColor:this.landingPage.themeColor}
      }
      return {'background': this.landingPage.themeColor, 'color': this.value.inverseColors?this.landingPage.secondaryColor:this.landingPage.negativeColor}
    }
  },
  computed: {
    tinaswishValue() {
      if (window.location.href.match("cc.tinaswishbenefit")) {
        return "To Remove Closed Captions";
      }
      return this.value.title;
    },
    tinaswishLink() {
      if (window.location.href.match("cc.tinaswishbenefit")) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style scoped>
.play-icon {
    border: 2px solid;
    border-radius: 100px;
    width: 35px;
    height: 35px;
    position: absolute;
    top: 25%;
    left: 40%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-left: 6px;
    background: #ffffff2e;
    color:rgba(255, 255, 255, 0.5);
    box-shadow: 1px 1px 9px #00000042;
    font-size: 15px;
    transition: all ease 0.2s;
}
.party-link:hover .play-icon{
      color:rgba(255, 255, 255, 0.9);
      box-shadow: 2px 2px 9px #00000082;
}
.party-link.link-image{
  position: relative;
  height: 222px;
  padding: 0;
  white-space: normal;
  background: white;
  overflow: hidden;
  vertical-align: top;
  border-radius: 2px;
  box-shadow: 0 0 30px lightgray;
  max-width: 280px;
}
.party-link.link-image>img{
  height: 160px;
  width: 100%;
  display: block;
  padding-bottom: 10px;
  object-fit: cover;
}

@media screen and (max-width: 500px) {
  .party-link.link-image{
    height: 180px;
  max-width: 44%;
}
  .party-link.link-image>img{
    height: 115px;

  }
  }


</style>